export default __webpack_public_path__ + "static/media/photo-1552058544-f2b08422138a.ebadf7d3.jpeg";